import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";


export const ApprovalDecisionModal = ({
    show,
    onHide,
    onSubmit,
    title = "Approval to allow student",
    style,
}) => {
    const [remarks, setRemarks] = useState("");
    const [pendingStatus, setPendingStatus] = useState(null); // null | "approved" | "rejected"
    const [remarksError, setRemarksError] = useState("");

    // Start fresh every time the modal is opened
    useEffect(() => {
        if (show) {
            setRemarks("");
            setPendingStatus(null);
            setRemarksError("");
        }
    }, [show]);

    const choose = (status) => {

        setRemarksError("");
        setPendingStatus(status);
    };

    const confirm = () => {
        const status = pendingStatus;
        setPendingStatus(null); // prevents a double click from submitting twice
        onSubmit(status, remarks.trim());
        onHide();
    };

    const isApprove = pendingStatus === "approved";

    return (
        <>
            {/* Step 1: remarks + decision */}
            <Modal show={show && !pendingStatus} onHide={onHide} style={style}>
                <Modal.Header>
                    <h3>{title}</h3>
                </Modal.Header>
                <Modal.Body className="text-left m-3">
                    <Form.Group className="mb-3">
                        <Form.Label>
                            Remarks
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            name="remarks"
                            value={remarks}
                            isInvalid={!!remarksError}
                            onChange={(event) => {
                                setRemarks(event.target.value);
                                if (remarksError) setRemarksError("");
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {remarksError}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="success"
                        onClick={() => choose("approved")}
                    >
                        Approve
                    </Button>
                    <Button variant="danger" onClick={() => choose("rejected")}>
                        Reject
                    </Button>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Step 2: confirm. Cancel goes back to step 1 with remarks kept */}
            <Modal
                show={show && !!pendingStatus}
                onHide={() => setPendingStatus(null)}
                style={style}
                centered
            >
                <Modal.Header>
                    <h3>
                        {isApprove ? "Confirm approval" : "Confirm rejection"}
                    </h3>
                </Modal.Header>
                <Modal.Body className="text-left m-3">
                    <p className="mb-2">
                        {isApprove
                            ? "Are you sure you want to approve this request? Students will be allowed to be synced to enrolment."
                            : "Are you sure you want to reject this request? The requester will be notified."}
                    </p>
                    {remarks.trim() && (
                        <p className="mb-0">
                            <b>Remarks:</b> {remarks.trim()}
                        </p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant={isApprove ? "success" : "danger"}
                        onClick={confirm}
                    >
                        {isApprove ? "Yes, approve" : "Yes, reject"}
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => setPendingStatus(null)}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
